import { render, staticRenderFns } from "./ButtonScrollToTop.vue?vue&type=template&id=addc1ee2"
import script from "./ButtonScrollToTop.vue?vue&type=script&lang=js"
export * from "./ButtonScrollToTop.vue?vue&type=script&lang=js"
import style0 from "./ButtonScrollToTop.vue?vue&type=style&index=0&id=addc1ee2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports